import React from 'react';

interface CompanyLegalInfoProps {
  formData: any;
  handleChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => void;
}

export const CompanyLegalInfo: React.FC<CompanyLegalInfoProps> = ({ formData, handleChange }) => {
  return (
    <div className="form-section">
      <h3>Legal & Tax Information</h3>
      <div className="form-grid">
        <div className="form-group">
          <label htmlFor="tax_id">Tax ID</label>
          <input
            type="text"
            id="tax_id"
            name="tax_id"
            value={formData.tax_id}
            onChange={handleChange}
            className="form-control"
          />
        </div>
        <div className="form-group">
          <label htmlFor="vat_number">VAT Number</label>
          <input
            type="text"
            id="vat_number"
            name="vat_number"
            value={formData.vat_number}
            onChange={handleChange}
            className="form-control"
          />
        </div>
        <div className="form-group">
          <label htmlFor="registration_number">Registration Number</label>
          <input
            type="text"
            id="registration_number"
            name="registration_number"
            value={formData.registration_number}
            onChange={handleChange}
            className="form-control"
          />
        </div>
        <div className="form-group">
          <label htmlFor="court_registration">Court Registration</label>
          <input
            type="text"
            id="court_registration"
            name="court_registration"
            value={formData.court_registration}
            onChange={handleChange}
            placeholder="e.g., HRB 123456"
            className="form-control"
          />
        </div>
        <div className="form-group">
          <label htmlFor="court_location">Court Location</label>
          <input
            type="text"
            id="court_location"
            name="court_location"
            value={formData.court_location}
            onChange={handleChange}
            placeholder="e.g., Amtsgericht Berlin"
            className="form-control"
          />
        </div>
      </div>
    </div>
  );
};